import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

class AssetsListHeader extends PureComponent {
  static propTypes = {
    canAdd: PropTypes.bool,
    companyId: PropTypes.string.isRequired,
    handleExport: PropTypes.func.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  handleExport = (e) => {
    e.preventDefault();
    this.props.handleExport();
  };

  render = () => (
    <Common.Header title={this.props.t('assets.title')}>
      <div className="btn-group pull-right">
        {this.props.canAdd && (
          <Form.Link
            to={createRoute(this.props.companyId, this.props.subcompanyId, 'assets/add')}
            className="btn btn-info"
          >
            {this.props.t('actions.add')}
          </Form.Link>
        )}

        <Common.Dropdown>
          <Common.DropdownElement onClick={this.handleExport}>
            <i className="fa fa-table mr-1" />
            {'  '}
            {this.props.t('actions.exportCSV')}
          </Common.DropdownElement>
        </Common.Dropdown>
      </div>
    </Common.Header>
  );
}

export default translate()(AssetsListHeader);



// WEBPACK FOOTER //
// src/components/assets/AssetsListHeader.js